import { useMemo } from "react";

import { useDefaultEvents } from "@Components/Grid";

export default function useEvents() {
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
  }), [handleUpdateEntry, handleDeleteEntry])
}
